import { PageId } from '../../../constants';
import { BaseAddPage } from './base-add-page';
import {
  getBookingsDefId,
  getTPAMainSectionStructure,
  isBookingsListInstalled,
} from '../../editor-sdk-actions';
import { addBookingsPagesAsPanel } from '../../pages-panel-actions';

export class AddServiceListPage extends BaseAddPage {
  constructor(protected editorSDK, protected appToken, protected instance) {
    super(editorSDK, appToken, instance);
  }

  public async shouldAddPage(): Promise<boolean> {
    return !(await isBookingsListInstalled(this.editorSDK));
  }

  public async execute() {
    const bookingsDefId = await getBookingsDefId(this.editorSDK);

    let schedulerSectionStructure = await getTPAMainSectionStructure(
      this.editorSDK,
      this.appToken,
      bookingsDefId,
    );

    if (!schedulerSectionStructure) {
      try {
        await this.addBookingsPage(PageId.BOOKINGS_LIST);

        schedulerSectionStructure = await getTPAMainSectionStructure(
          this.editorSDK,
          this.appToken,
          bookingsDefId,
        );
      } catch (e) {
        const errorMessage = `${
          e?.message ? e.message : JSON.stringify(e)
        } - errorCode: ADD_BOOKINGS_LIST_FAILED`;
        console.log(errorMessage);
      }
    }

    if (!schedulerSectionStructure) {
      throw new Error(
        'schedulerSectionStructure not found in getTPAMainSectionStructure for bookingsListInstalled - errorCode: SCHEDULER_NOT_FOUND_BOOKINGS_LIST',
      );
    }

    await addBookingsPagesAsPanel(this.editorSDK, this.appToken);
  }

  protected get widgetId() {
    return '54d912c5-52cb-4657-b8fa-e1a4cda8ed01';
  }

  public get widgetName() {
    return 'AddServiceListPage';
  }

  public get stepTranslate() {
    return 'service-page-migration.progress-bar.step-1';
  }
}
